import {SET_MESSAGE, CLEAR_MESSAGE, SET_RESPONSE, CLEAR_RESPONSE, SET_TOKEN, CLEAR_TOKEN} from "./types";

export const setMessage = (message) => ({
    type: SET_MESSAGE,
    payload: message,
});

export const clearMessage = () => ({
    type: CLEAR_MESSAGE,
});


export const setResponse = (response) => ({
    type: SET_RESPONSE,
    payload: response,
});

export const clearResponse = () => ({
    type: CLEAR_RESPONSE,
});

export const setToken = (token) => ({
    type: SET_TOKEN,
    payload: token,
});

export const clearToken = () => ({
    type: CLEAR_TOKEN,
});



